import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Modals from 'components/Modals';
import useModalLogic from 'hooks/useModalLogic';
import RegistrationModel from 'models/users/registrationModel';
import React, { useContext, useState } from 'react';
import { Button } from 'react-bootstrap';
import * as Context from './Context';
import * as Forms from './Forms';

const defaultAccess: RegistrationModel = {
  email: '',
  password: '',
};

const Create = () => {
  const { registerUser } = useContext(Context.default);
  const [binding, setBinding] = useState<RegistrationModel>(defaultAccess);
  const [open, setOpen] = useState(false);

  const submit = async () => registerUser(binding);
  const [handleSubmit, handleClose, error] = useModalLogic<RegistrationModel>(
    submit,
    () => setOpen(false),
    () => setBinding(defaultAccess),
  );

  return (
    <>
      <Button title="Opret bruger" onClick={() => setOpen(true)}>
        <FontAwesomeIcon icon={faPlus} />
      </Button>
      <Modals.Create
        title="Opret bruger"
        onClose={handleClose}
        open={open}
        onSubmit={handleSubmit}
      >
        <Forms.Create value={binding} onChange={setBinding} error={error} />
      </Modals.Create>
    </>
  );
};
export default Create;
